export function dmConversationId(a: string, b: string): string {
  const [x, y] = [a, b].sort();
  return `dm:${x}:${y}`;
}

/** Given a DM conversation id and the current user id, return the other participant. */
export function peerIdFromDmConversation(convId: string, myId: string): string | null {
  if (!convId.startsWith('dm:')) return null;
  const parts = convId.split(':');
  if (parts.length < 3) return null;
  const [, x, y] = parts;
  if (x === myId) return y ?? null;
  if (y === myId) return x ?? null;
  return null;
}
